var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"Tools"}},[_c('div',{staticClass:"charts-tools"},[_c('h1',[_vm._v("CJM")]),_c('c-j-m-median-latest',{staticClass:"chart"}),_c('c-j-m-tariffs-latest',{staticClass:"chart"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }